function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 38.49c-.12-2.09-.24-4.26-.39-6.83H6.42C2.24 31.57.07 29.38.07 25.32v-19c0-3.9 2.27-6.21 6.2-6.23Q19.85 0 33.42.09c4.08 0 5.62 1.66 5.63 5.75v20.52c0 3.43-1.51 5.59-4.82 5.23-7.67-.86-14 1.26-19.46 6.6a3.06 3.06 0 01-1 .51c-.26-.01-.48-.13-1.02-.21z",
  fill: "#fff"
});

var SvgMessageIcon = function SvgMessageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39.01 38.66"
  }, props), _ref);
};

export default SvgMessageIcon;